<template>
  <b-modal :visible="show" :hide-header="true" centered id="modal-sucesso" size="lg" :hide-footer="true"
    no-close-on-backdrop>
    <div class="float-right"><img @click="hide" class="close" src="img/x-icon.svg" /></div>
    <div class="row text-center">
      <div class="col-sm-12 col-12 mt-2 pr-0 pl-0">
        <div class="text-center">
          <h3 class="text-info">Parabéns 🎉</h3>
          <h5 class="text-info">Pesquisa finalizada com sucesso</h5>
          <img height="200" src="img/casal-idoso-feliz.png" />
        </div>

        <button class="btn confirm mb-3" @click="$router.push('main')">
          <span class="text">Continuar</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: ["show"],
  data() {
    return {};
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
  },
};
</script>

<style>
#modal-sucesso___BV_modal_content_ {
  border-radius: 12px !important;
  padding: 18px;
  padding-top: 15px;
}

.ghost {
  font-weight: 600;
  text-decoration: none;
  border: 1px solid;
  border-radius: 7px;
  padding: 15px;
}

.title-bold {
  font-weight: 800;
}

.close {
  width: 15px;
  cursor: pointer;
}

.vw-20 {
  width: 20vw;
}

.voltar {
  color: #9a9a9a;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
}

.confirm {
  font-size: 18px;
  padding: 12px 20px 12px 20px;
  border-radius: 7px;
  border: 1px solid #0D4275;
  background: #0D4275;
  color: #fff;
  font-weight: 600;
}

.title-modal-falha {
  color: #425994;
}

.sub-title-modal-falha {
  color: #78849E;
}


@media (max-width: 768px) {

  .title-modal-falha {
    font-size: 20px !important;
    font-weight: bold;
  }

  .sub-title-modal-falha {
    font-size: 14px !important;
  }

  .sub-title {
    font-size: 17px;
  }

  .title {
    font-size: 20px;
  }

  .vw-m-60 {
    width: 60vw;
  }

  #modal-sucesso___BV_modal_content_ {
    padding: 0 !important;
    padding-top: 0 !important;
  }

  .desktop {
    display: none !important
  }
}

@media (min-width: 769px) {
  .mobile {
    display: none !important
  }
}
</style>